<template>
  <div :id="popupId" class="popup" :class="modalType" role="dialog" aria-hidden="true" aria-modal="true" tabindex="-1">
    <div class="pop-bg-close ui-pop-close" role="button" aria-label="팝업창 닫기" @click="closeCallBack"></div>
    <article class="pop-wrap" :class="article">
      <div class="pop-head">
        <div>
          <slot name="header"></slot>
          <button
              type="button"
              class="pop-close ui-pop-close"
              aria-label="팝업창 닫기"
              @click="closeCallBack"
          ></button>
        </div>
      </div>

      <div class="pop-body">
        <div class="section" :class="bodyType">
          <slot></slot>
        </div>
      </div>

      <div class="bottom-fixed">
        <div class="btn-wrap">
          <slot name="footer"></slot>
          <div class="flex" v-if="btnType !== ''">
            <button v-if="btnType !== 'singleButton'" type="button" class="btn btn-gray ui-pop-close" @click="closeCallBack">{{ closeBtnName }}</button>
            <button type="button" class="btn btn-primary ui-pop-close" @click="selectCallBack">{{ selectBtnName }}</button>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script setup>
import {togglePop} from '@/utils/commonUi';

const props = defineProps({
  popupId: String,
  modalType: [Object, String],
  bodyType: String,
  btnType: {
    type: String,
    default: ''
  },
  selectBtnName: {
    type: String,
    default: '확인'
  },
  closeBtnName: {
    type: String,
    default: '취소'
  },
  article: {
    type: String,
    default: ''
  },
  closePopYn: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:selectCallBack', 'update:closeCallBack']);

//팝업창 확인 후 이벤트 전달
const selectCallBack = (popupId, shouldShow) => {
  togglePop(props.popupId, false);
  emit('update:selectCallBack');
}

//팝업창 취소 후 이벤트 전달
const closeCallBack = (popupId, shouldShow) => {
  if (!props.closePopYn) {
    togglePop(props.popupId, false);
  }
  emit('update:closeCallBack');
}
</script>
